import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const WritingTask1Listening = () => {
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const [audioEnded, setAudioEnded] = useState(false);

  const audioUrl = "https://res.cloudinary.com/dyvopisyr/video/upload/v1744620265/Mock1Writing1.mp3_ppzmyz.mp3";
  const imageSrc = ""; // 🌟 Optional illustration

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.play().catch((err) => console.error("AutoPlay failed:", err));
    }
  }, []);

  const handleAudioEnd = () => {
    setAudioEnded(true);
  };

  const handleContinue = () => {
    navigate('/lessonMock/mock1/writing/1/write');
  };

  return (
    <div className="p-8 max-w-3xl mx-auto text-center">
      <h1 className="text-2xl font-bold mb-6 text-darkblue-800">Writing Task 1 - Listen to the Lecture</h1>

      {imageSrc && (
        <img
          src={imageSrc.startsWith('http') ? imageSrc : `/images/${imageSrc}`}
          alt="Lecture Illustration"
          className="mb-6 mx-auto max-h-64 object-contain"
        />
      )}

      <p className="mb-4 text-gray-700">
        Listen to the lecture carefully. Take notes as you listen. You will only hear it once.
      </p>

      {!audioEnded && (
  <audio
    ref={audioRef}
    src={audioUrl}
    onEnded={handleAudioEnd}
    controls
    className="w-full mb-6"
  />
)}


      <button
        onClick={handleContinue}
        disabled={!audioEnded}
        className={`mt-6 px-6 py-3 rounded-lg text-white font-semibold ${
          audioEnded ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-400 cursor-not-allowed'
        }`}
      >
        {audioEnded ? 'Continue to Writing Response' : 'Please finish listening first'}
      </button>
    </div>
  );
};

export default WritingTask1Listening;
